import React, { lazy } from 'react';

import ClientOnly from '../../../ClientOnly';
import { LocationSearch } from '@components/Select';

import 'react-datepicker/dist/react-datepicker.css';
import scss from './Filters.module.scss';
import { Region } from '@api/getregions';

const DatePicker = lazy(() => import('ui/DatePicker/DatePicker').then((module) => ({ default: module['DatePickerWithLabel'] })));

interface FiltersBaseProps {
    initialRegionId: number | null;
    region: Region | null;
    weddingDate: Date | null;
    setRegion: React.Dispatch<React.SetStateAction<Region | null>>;
    setWeddingDate: React.Dispatch<React.SetStateAction<Date | null>>;
}

const FiltersBase = ({ initialRegionId, region, weddingDate, setRegion, setWeddingDate }: FiltersBaseProps) => (
    <div className={scss.filterForm}>
        <div className={!region ? scss.highlighted : undefined}>
            <LocationSearch
                label="region"
                placeholder="Select your region"
                initialRegionId={!!initialRegionId ? initialRegionId : undefined}
                currentRegion={region}
                customButtonClass={scss.regionButton}
                setCurrentRegion={setRegion}
            />
        </div>
        <div className={!weddingDate ? scss.highlighted : undefined}>
            <ClientOnly Component={DatePicker}
                label="Wedding Date"
                placeholderText={'Select date'}
                selected={weddingDate}
                minDate={new Date()}
                onChange={(date: Date | null) => setWeddingDate(date)}
            />
        </div>
    </div>
);

export default FiltersBase;